import { Link, useLoaderData } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { Button } from "@/components/ui/button";
import { TicketSyncSection } from "./ticket-sync-section";

export function TicketSyncPage() {
  const { ticketSyncSettings, ticketSyncHistory, totalLocalTickets } = useLoaderData({
    from: "/_authenticated/data-sync/tickets",
  }) as {
    ticketSyncSettings: {
      intervalMs: number;
      lastSyncedAt: string | null;
      schedulerActive: boolean;
      backfillCompletedAt: string | null;
    };
    // biome-ignore lint/suspicious/noExplicitAny: loader data shape mirrors API JSON
    ticketSyncHistory: any[];
    totalLocalTickets: number;
  };

  return (
    <div className="space-y-6">
      <PageHeader
        title="Ticket Sync"
        description="Mirror HubSpot tickets (repairs, returns, service) to local database"
        actions={
          <Button variant="outline" size="sm" asChild>
            <Link to="/data-sync">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Data Sync
            </Link>
          </Button>
        }
      />

      <TicketSyncSection
        initialSettings={ticketSyncSettings}
        initialHistory={ticketSyncHistory}
        totalTickets={totalLocalTickets}
      />
    </div>
  );
}
